import React, { useEffect, useRef } from 'react';
import ScrollBooster from 'scrollbooster';

const scrollBySectionAndScrollId = {};

export function resetSavedScrollPositions(sectionId) {
  delete scrollBySectionAndScrollId[sectionId];
}

export function Scroller({
  sectionId = '',
  scrollId,
  children,
  onScroller,
  deps,

  viewport,
  content,
  scrollMode = 'native',
  direction = 'vertical',
  bounce,
  textSelection,
  inputsFocus,
  pointerMode = 'mouse',
  friction,
  bounceForce,
  emulateScroll,
  preventDefaultOnEmulateScroll,
  lockScrollOnDragDirection,
  dragDirectionTolerance,
  onUpdate,
  onClick,
  onPointerDown,
  onPointerUp,
  onPointerMove,
  onWheel,
  shouldScroll,

  onScroll,
  ...props
}) {
  const scrollBoosterRef = useRef(null);
  const elRef = useRef(null);
  if (scrollBoosterRef.current) {
    scrollBoosterRef.current.updateMetrics();
    requestAnimationFrame(
      () => scrollBoosterRef.current && scrollBoosterRef.current.updateMetrics()
    );
  }

  useEffect(() => {
    if (!(sectionId in scrollBySectionAndScrollId))
      scrollBySectionAndScrollId[sectionId] = {};
    if (scrollId && elRef.current) {
      elRef.current[[direction === 'horizontal' ? 'scrollLeft' : 'scrollTop']] =
        scrollBySectionAndScrollId[sectionId][scrollId] || 0;
    }
  }, [sectionId, scrollId]);

  return (
    <div
      {...props}
      ref={(el) => {
        elRef.current = el;
        if (scrollBoosterRef.current?.props?.viewport === el) return;

        if (el) {
          if (scrollBoosterRef.current?.destroy)
            scrollBoosterRef.current.destroy();

          const scrollBoosterOptions = {
            ...Object.fromEntries(
              Object.entries({
                viewport: viewport || el,
                content,
                scrollMode,
                direction,
                bounce,
                textSelection,
                inputsFocus,
                pointerMode,
                friction,
                bounceForce,
                emulateScroll,
                preventDefaultOnEmulateScroll,
                lockScrollOnDragDirection,
                dragDirectionTolerance,
                onUpdate,
                onClick,
                onPointerDown,
                onPointerUp,
                onPointerMove,
                onWheel,
              }).filter(([_, value]) => value !== undefined)
            ),
          };

          scrollBoosterRef.current = new ScrollBooster(scrollBoosterOptions);

          if (typeof onScroller === 'function')
            onScroller(scrollBoosterRef.current);
        }
      }}
      onScroll={(event) => {
        scrollBySectionAndScrollId[sectionId][scrollId] =
          event.target[direction === 'horizontal' ? 'scrollLeft' : 'scrollTop'];

        if (typeof onScroll === 'function') onScroll(event);
      }}
    >
      {children}
    </div>
  );
}
